import type { Path, UseFormRegister } from 'react-hook-form';
import type { FieldValues } from 'react-hook-form';
import styled, { css } from 'styled-components';

import { InputStatus } from './InputStatus';

type TInputStatuses<Fields extends FieldValues> = {
  name?: Path<Fields>;
  type: 'application' | 'loan';
  state?: Array<string>;
  reset: boolean;
  register?: UseFormRegister<Fields>;
};

const StatusesWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
  `
);

const StatusesTitle = styled.div(
  ({ theme }) => css`
    flex: 0 0 100%;
    margin: 0 6px;
    font-weight: 500;
  `
);

const InputStatuses = <Fields extends FieldValues>({
  name,
  type,
  state = [],
  reset,
  register
}: TInputStatuses<Fields>) => {
  let statuses = [];

  if (type === 'application') {
    statuses = [
      'NEW - Entered',
      'Pending Approval',
      'Approved',
      'Signed',
      'Cancelled',
      'Rejected',
      'Payment Assist - Refer',
      'Pending ID'
    ];
  } else {
    statuses = [
      'Approved',
      'Active - Good Standing',
      'Active - Bad Standing',
      'Approved - Not signed',
      'Closed'
    ];
  }

  return (
    <StatusesWrapper>
      <StatusesTitle>Statuses</StatusesTitle>
      {statuses.map((status) => (
        <InputStatus
          key={status}
          status={status}
          type={type}
          reset={reset}
          name={name}
          checked={state?.includes(status)}
          register={register}
        />
      ))}
    </StatusesWrapper>
  );
};

export { InputStatuses };
